export default "__VITE_PUBLIC_ASSET__174a45b6__"